import './assets/form-control-label.css';
import { jsxs as n, jsx as b } from "react/jsx-runtime";
import _ from "clsx";
const c = "_label_10r6b_1", i = "_label_error_10r6b_15", p = "_label_optional_10r6b_19", l = {
  label: c,
  label_error: i,
  label_optional: p
}, x = (o) => {
  const { children: r, hasError: a, isOptional: e, className: s, ...t } = o;
  return /* @__PURE__ */ n("label", { className: _(l.label, { [l.label_error]: a }, s), ...t, children: [
    r,
    e && /* @__PURE__ */ b("span", { className: l.label_optional, children: " (optional)" })
  ] });
};
export {
  x as FormControlLabel
};
